import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { PLACEHOLDERS } from './errorReportColumns';

const STATUS_KEYS = { Beklemede: 'pending', 'İşlemde': 'inProgress', 'Tamamlandı': 'completed', 'İptal': 'cancelled' };

/**
 * Texts of Çalışan Hata Geribildirimleri (`errorReports.*`). Stored statuses
 * stay Turkish; `statusLabel` only labels them. `formatDate` shows a stored
 * timestamp in the UI language. The Excel file keeps its old layout.
 */
const useErrorReportText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`errorReports.${key}`, vars), [t]);
  const statusLabel = useCallback((value) => (STATUS_KEYS[value] ? t(`errorReports.status.${STATUS_KEYS[value]}`) : value || ''), [t]);
  const formatDate = useCallback((value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString(locale, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }, [locale]);
  /** A report field, or '' while it only holds the old page's placeholder. */
  const fieldText = useCallback((report, key) => {
    const value = report?.[key];
    if (value === undefined || value === null || value === '' || value === PLACEHOLDERS[key]) return '';
    return String(value);
  }, []);
  return { t, language, locale, label, statusLabel, formatDate, fieldText };
};

export default useErrorReportText;
